import { logException } from 'shared/lib/utils';

export function getL10n() {
  return fetch(
    `${process.env.REACT_APP_SURE_API_BASE_URL}/api/user/v2/info/l10n`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }
  ).then(response => {
    if (response.status >= 400) {
      return response.json().then(errorResp => {
        const error = new Error(response.statusText);
        logException(error, {
          response: errorResp,
        });
        throw error;
      });
    } else {
      return response.json();
    }
  });
}
